import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { GoodsPiece } from 'shared/src/api/goodsService';
import { useGetMeasureValues } from '../hooks/useGetMeasureValues';

interface Props {
  piece: GoodsPiece;
}

export const MeasurementSizeDetailTable: React.FC<Props> = ({ piece }) => {
  const getMeasureValues = useGetMeasureValues();
  const { measureValues: tableHeadColumns, sizes } = getMeasureValues(piece);

  const headers = sizes.map(size => size.name);

  if (tableHeadColumns.length === 0) {
    return null;
  }

  return (
    <Flex borderTopWidth={1} borderColor={'border_secondary'}>
      {/* Header Row */}
      <Flex.Row>
        <Flex.Center
          flex={1}
          padding={{ horizontal: 8, vertical: 10 }}
          borderRightWidth={1}
          borderBottomWidth={1}
          borderLeftWidth={1}
          borderColor={'border_secondary'}
          backgroundColor={'bg_secondary'}
        >
          <Typography type={'subtitle3'} color={'content_primary'}>
            사이즈
          </Typography>
        </Flex.Center>
        {headers.map(header => (
          <Flex.Center
            flex={1}
            key={header}
            padding={{ horizontal: 8, vertical: 10 }}
            borderRightWidth={1}
            borderBottomWidth={1}
            borderColor={'border_secondary'}
            backgroundColor={'bg_secondary'}
          >
            <Typography type={'subtitle3'} color={'content_primary'}>
              {header}
            </Typography>
          </Flex.Center>
        ))}
      </Flex.Row>

      {/* Data Rows */}
      {tableHeadColumns.map(column => (
        <Flex.Row key={column.spot.name}>
          <Flex.Center
            flex={1}
            padding={{ horizontal: 8, vertical: 10 }}
            borderRightWidth={1}
            borderBottomWidth={1}
            borderLeftWidth={1}
            borderColor={'border_secondary'}
            backgroundColor={'bg_primary'}
          >
            <Typography
              type={'body3'}
              color={'content_primary'}
              numberOfLines={1}
            >
              {column.spot.name}
            </Typography>
          </Flex.Center>
          {headers.map(header => {
            const matchedSize = sizes.find(size => size.name === header);
            const measureValue = matchedSize?.measure_values?.find(
              mv => mv.spot.name === column.spot.name,
            );

            return (
              <Flex.Center
                flex={1}
                key={header}
                padding={{ horizontal: 8, vertical: 10 }}
                borderRightWidth={1}
                borderBottomWidth={1}
                borderColor={'border_secondary'}
                backgroundColor={'bg_primary'}
              >
                <Typography type={'body3'} color={'content_primary'}>
                  {measureValue?.value ?? '-'}
                </Typography>
              </Flex.Center>
            );
          })}
        </Flex.Row>
      ))}
    </Flex>
  );
};
